import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import accounts from './modules/accounts'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    accounts
  }
})